import { useEffect, RefObject } from 'react';

export const useRippleEffect = (ref: RefObject<HTMLButtonElement>) => {
  useEffect(() => {
    if (!ref.current) return;

    const button = ref.current;

    const createRipple = (event: MouseEvent) => {
      const ripple = document.createElement('span');
      const rect = button.getBoundingClientRect();
      const size = Math.max(button.clientWidth, button.clientHeight);
      const x = event.clientX - rect.left - size / 2;
      const y = event.clientY - rect.top - size / 2;

      ripple.style.width = ripple.style.height = `${size}px`;
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      ripple.className = 'ripple';

      button.appendChild(ripple);

      setTimeout(() => {
        ripple.remove();
      }, 400);
    };

    button.addEventListener('click', createRipple);

    return () => {
      button.removeEventListener('click', createRipple);
    };
  }, [ref]);
};
